import { createInMemoryStorageHandler, StorageHandler } from "@/lib/storage";
import { makeAutoObservable } from "mobx";

export interface ChecklistState {
  activeChecklistId?: string;
  dismissedChecklistIds?: string[];
  isMinimized?: boolean;
}

export class ChecklistStateStorage {
  private isPreview: boolean;
  private storage: StorageHandler;
  private _state: ChecklistState;

  constructor(isPreview: boolean, storage: StorageHandler) {
    this.isPreview = isPreview;
    this.storage = storage;
    this._state = this.get();
    makeAutoObservable(this);
  }

  get() {
    return this.storage.get(this.storageKey(), {});
  }

  set(state: Partial<ChecklistState>): void {
    this._state = { ...this._state, ...state };
    this.storage.set(this.storageKey(), this._state);
  }

  setActiveChecklistId(checklistId: string) {
    this.set({ activeChecklistId: checklistId });
  }

  addDismissedChecklistId(checklistId: string) {
    this.set({ dismissedChecklistIds: [...(this._state.dismissedChecklistIds || []), checklistId] });
  }

  getActiveChecklistId() {
    return this._state.activeChecklistId;
  }

  clearActiveChecklistId() {
    this.set({ activeChecklistId: undefined });
  }

  setIsMinimized(isMinimized: boolean) {
    this.set({ isMinimized });
  }

  get isMinimized() {
    return this._state.isMinimized;
  }

  clear() {
    this.storage.remove(this.storageKey());
    this._state = {};
  }

  private storageKey(): string {
    return `pyne-checklist-state${this.isPreview ? "preview" : ""}`;
  }
}

export const buildInMemoryUserStateStorage = () => new ChecklistStateStorage(false, createInMemoryStorageHandler());
